import {IInsurance} from "@/model/Insurance/Insurance"

export interface IHasInsurancesEligible {
    getInsurancesEligible(): IInsurance[]
    getInsurancesEligibleMap(): Map<string, IInsurance>
    addInsuranceEligible(service: IInsurance): void
    removeInsuranceEligible(service: IInsurance): void
}

function hasInsurancesEligible<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsurancesEligible {
        private insurancesEligible: IInsurance[] = []
        private insurancesEligibleMap: Map<string, IInsurance> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsurancesEligible(): IInsurance[] {
            return this.insurancesEligible
        }
        public getInsurancesEligibleMap(): Map<string, IInsurance> {
            return this.insurancesEligibleMap
        }
        public addInsuranceEligible(service: IInsurance): void {
            if (this.insurancesEligibleMap.has(service.getIdFull())) return
            this.insurancesEligible.push(service)
            this.insurancesEligibleMap.set(service.getIdFull(), service)
        }
        public removeInsuranceEligible(service: IInsurance): void {
            if (!this.insurancesEligibleMap.has(service.getIdFull())) return
            this.insurancesEligible = this.insurancesEligible.filter((existingInsurance: IInsurance) => existingInsurance.getIdFull() !== service.getIdFull())
            this.insurancesEligibleMap.delete(service.getIdFull())
        }
    };
}

export default hasInsurancesEligible